import { forwardRef, TextareaHTMLAttributes } from 'react';
import type { SxProps } from '@mui/material';

import { StyledTextarea } from './Textarea.style';

type TextareaProps = {
  sx?: SxProps;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ disabled, onChange, ...rest }, ref) => (
    <StyledTextarea
      {...rest}
      ref={ref}
      disabled={disabled}
      onChange={disabled ? undefined : onChange}
    />
  )
);

export default Textarea;
